var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.8125V5.625C12 4.29892 11.4732 3.02715 10.5355 2.08947C9.59785 1.15178 8.32608 0.625 7 0.625C5.67392 0.625 4.40215 1.15178 3.46447 2.08947C2.52678 3.02715 2 4.29892 2 5.625V7.8125H0.4375V12.8125C0.4375 16.4311 3.38141 19.375 7 19.375C10.6186 19.375 13.5625 16.4311 13.5625 12.8125V7.8125H12ZM3.25 5.625C3.25 4.63044 3.64509 3.67661 4.34835 2.97335C5.05161 2.27009 6.00544 1.875 7 1.875C7.99456 1.875 8.94839 2.27009 9.65165 2.97335C10.3549 3.67661 10.75 4.63044 10.75 5.625V7.8125H3.25V5.625ZM12.3125 12.8125C12.3125 15.7418 9.9293 18.125 7 18.125C4.0707 18.125 1.6875 15.7418 1.6875 12.8125V9.0625H12.3125V12.8125Z",
    fill: "#9D9D9D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.ac1d44664f154e6b38dc71c65106133a.svg";
export { ForwardRef as ReactComponent };